import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoginNewComponent } from "@app/modules/auth/pages/login-new/login-new.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "/auth/login",
    pathMatch: "full",
  },
  {
    path: "",
    children: [
      {
        path: "login",
        component: LoginNewComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
